var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOurBeginningsSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_1427_15852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.0867 27.6069H14.3586C13.2586 27.6069 12.3633 26.7108 12.3633 25.6085C12.3633 24.5069 13.2586 23.6108 14.3586 23.6108H22.6008L20.8617 21.2671H14.3586C11.9664 21.2671 10.0195 23.2147 10.0195 25.6085C10.0195 28.003 11.9664 29.9507 14.3586 29.9507H36.0867C37.2281 29.9507 38.157 30.8804 38.157 32.0241C38.157 33.1679 37.2281 34.0976 36.0867 34.0976H12.2008C12.3268 34.8476 12.3352 35.6419 12.2008 36.4413H36.0867C38.5203 36.4413 40.5008 34.4601 40.5008 32.0241C40.5008 29.5882 38.5203 27.6069 36.0867 27.6069Z",
    fill: "#2A3142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.22695 30.5396C2.62055 30.5396 0.5 32.6616 0.5 35.2699C0.5 37.8781 2.62055 40.0001 5.22695 40.0001C7.83336 40.0001 9.95391 37.8781 9.95391 35.2699C9.95391 32.6617 7.83336 30.5396 5.22695 30.5396ZM5.22695 37.6563C3.91289 37.6563 2.84375 36.5857 2.84375 35.2699C2.84375 33.954 3.91289 32.8834 5.22695 32.8834C6.54102 32.8834 7.61016 33.954 7.61016 35.2699C7.61016 36.5857 6.54102 37.6563 5.22695 37.6563Z",
    fill: "#2A3142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.9885 10.1181C26.6348 10.1181 27.1607 9.59133 27.1607 8.94383C27.1607 8.29633 26.6349 7.76953 25.9885 7.76953C25.3423 7.76953 24.8164 8.29633 24.8164 8.94383C24.8164 9.59133 25.3423 10.1181 25.9885 10.1181Z",
    fill: "#2A3142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.1076 23.0592C25.5774 23.6925 26.5301 23.6917 26.9966 23.05L33.1587 14.5733C37.697 8.67477 33.5081 0 25.9866 0C18.5009 0 14.3197 8.58953 18.7502 14.4887C18.7727 14.5213 18.4698 14.1114 25.1076 23.0592ZM25.9865 5.42562C27.9252 5.42562 29.5024 7.00383 29.5024 8.94367C29.5024 10.8835 27.9252 12.4617 25.9865 12.4617C24.0479 12.4617 22.4706 10.8835 22.4706 8.94367C22.4706 7.00383 24.0479 5.42562 25.9865 5.42562Z",
    fill: "#2A3142"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1427_15852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurBeginningsSvg);
export default __webpack_public_path__ + "static/media/OurBeginningsSvg.1db0ca2a5e40b39c48d4c0cc388e906c.svg";
export { ForwardRef as ReactComponent };